import React, { useState, useMemo, createContext } from "react";

const QueueSelectedContext = createContext();

const QueueSelectedProvider = ({ children }) => {
	const [selectedQueuesMessage, setSelectedQueuesMessage] = useState([]);
	const contextValue = useMemo(() => ({
		selectedQueuesMessage,
		setSelectedQueuesMessage
	}), [selectedQueuesMessage]);

	return (
		<QueueSelectedContext.Provider value={contextValue}>
			{children}
		</QueueSelectedContext.Provider>
	);
};

export { QueueSelectedContext, QueueSelectedProvider };
